import React, { createContext, useContext } from 'react';
import { ProductState } from '../types';

export type ProductStateType = {
  productState: ProductState;
  setProductState: React.Dispatch<React.SetStateAction<ProductState>>;
  initialized: boolean;
};

export const ProductStateContext = createContext<ProductStateType | null>(null);

export function useProductState(): ProductStateType {
  const context = useContext(ProductStateContext);

  if (context === null) {
    throw new Error(
      'useProductState must be used within a ProductStateContextProvider'
    );
  }

  return context;
}
